// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"3dae7d16","88":"5445f945","213":"323392a6","271":"7ea9cb8b","349":"489b499b","405":"f5dd38de","442":"d6f19c23","488":"afd6e9c2","586":"dd48488b","596":"8a7cfdb5","722":"5a4ea40d","732":"e04df595","748":"eb3819d4","762":"c863f8ae","841":"6be5eada","885":"d894eb54"}[chunkId] + ".chunk.js";
};